import { defineMessages } from "react-intl";
import {
	diseasesMessages,
	helicobacterPyloriMessages,
	validator
} from "lib/build/forms/ltx/phase-i/medical-history/comorbidities/gastrointestinalDiseases";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	gastrointestinalDiseases: {
		id: "form.gastrointestinal_diseases",
		defaultMessage: "Gyomor- és bélrendszeri betegségek"
	},
	diseases: {
		id: "form.gastrointestinal_diseases.diseases",
		defaultMessage: "Betegség"
	},
	helicobacterPylori: {
		id: "form.gastrointestinal_diseases.helicobacter_pylori",
		defaultMessage: "Helicobacter pylori"
	},
	comment: {
		id: "form.gastrointestinal_diseases.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	diseases: {
		type: "field",
		path: ["diseases"],
		label: messages.diseases,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: diseasesMessages } }
	},
	helicobacterPylori: {
		type: "field",
		path: ["helicobacterPylori"],
		label: messages.helicobacterPylori,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: helicobacterPyloriMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.diseases }] },
		{ columns: [{ width: 12, field: fields.helicobacterPylori }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "gastrointestinalDiseases",
	value: {
		title: messages.gastrointestinalDiseases,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
